export function isGoogleFontsUrl(url: string): boolean {
  return url.includes('fonts.googleapis.com');
}

export function extractGoogleFontFamily(url: string): string {
  const match = url.match(/family=([^:&]+)/);
  return match ? match[1].replace(/\+/g, ' ').split(':')[0] : '';
}

export function getCssFontFamily(url: string, originalName: string): string {
  if (isGoogleFontsUrl(url)) {
    return extractGoogleFontFamily(url) || getPlatformFontDisplayName(originalName);
  }
  return getPlatformFontDisplayName(originalName);
}

export function loadFont(theme_font_src: string, name: string): Promise<string> {
  if (isGoogleFontsUrl(theme_font_src)) {
    const linkId = `gfont-${encodeURIComponent(theme_font_src)}`;
    if (!document.getElementById(linkId)) {
      const link = document.createElement('link');
      link.id = linkId;
      link.rel = 'stylesheet';
      link.href = theme_font_src;
      document.head.appendChild(link);
    }
    return Promise.resolve(extractGoogleFontFamily(theme_font_src) || name);
  }

  document.fonts.forEach(face => {
    if (face.family === name) {
      document.fonts.delete(face);
    }
  });
  const font = new FontFace(name, `url(${theme_font_src})`);
  return font.load().then(face => {
    document['fonts'].add(face);
    return name;
  });
}

export function loadFontList(fonts: { name: string; url: string }[]) {
  fonts.forEach(font => {
    loadFont(font.url, font.name);
  });
}

export function getPlatformFontDisplayName(originalName: string): string {
  if (!originalName) {
    return '';
  }
  return originalName.split('.')[0];
}
